import React, { FC } from "react";
import { UserDisplayWrapperProps } from "@zeemee/react-web-chat";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";
import { AnalyticsEvent } from "@/hooks/useAnalytics";

export const UserDisplayWrapper: FC<UserDisplayWrapperProps> = ({
  user,
  children,
  ...props
}) => {
  const { navToRoute } = useProtectedNavigation();
  const { t } = useTranslation();

  if (user.__typename !== "Student") {
    return (
      <button
        {...props}
        onClick={(e) => {
          props.onClick?.(e);
          toast.error(t("chat.chatUserDisplayWrapper.notStudentTitle"), {
            description: t("chat.chatUserDisplayWrapper.notStudentText"),
            action: {
              label: t("global.close"),
              onClick: () => {
                // Close action - no additional logic needed
              },
            },
          });
        }}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      {...props}
      onClick={(e) => {
        props.onClick?.(e);
        navToRoute("student", { studentId: user.id }, {}, {
          analyticsEvent: AnalyticsEvent.OpenedProfile,
          analyticsProperties: { Source: "Chat" },
        });
      }}
    >
      {children}
    </button>
  );
};
